import * as yup from 'yup';

const hourRegex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;

yup.addMethod(yup.string, 'hour', function () {
  return this.test('hour', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (field && hourRegex.test(field.value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid hour' }));
      }
    });
  });
});

yup.addMethod(yup.string, 'endHour', function () {
  return this.test('endHour', function () {
    const { path, createError } = this;
    const error = { path, message: 'Invalid end hour' };
    const hourEndField = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (hourEndField && hourEndField.value) {
        const nameFieldHourStart = 'hourStart' + hourEndField.name.slice(7);
        const hourStartField = document.getElementsByName(
          nameFieldHourStart
        )[0];
        const hourStartValue = hourStartField.value.replace(/:/g, '');
        const hourEndValue = hourEndField.value.replace(/:/g, '');
        if (
          (hourStartValue === '0000' && hourEndValue === '0000') ||
          parseInt(hourStartValue, 10) < parseInt(hourEndValue, 10)
        ) {
          resolve(true);
        } else {
          reject(createError(error));
        }
      } else {
        reject(createError(error));
      }
    });
  });
});

const schema = yup.object().shape({
  name: yup
    .string()
    .required()
    .trim(),
  department: yup
    .string()
    .required()
    .trim(),
  hourStartWeekSun: yup.string().hour(),
  hourEndWeekSun: yup
    .string()
    .hour()
    .endHour(),
  hourStartWeekMon: yup.string().hour(),
  hourEndWeekMon: yup
    .string()
    .hour()
    .endHour(),
  hourStartWeekTue: yup.string().hour(),
  hourEndWeekTue: yup
    .string()
    .hour()
    .endHour(),
  hourStartWeekWed: yup.string().hour(),
  hourEndWeekWed: yup
    .string()
    .hour()
    .endHour(),
  hourStartWeekThu: yup.string().hour(),
  hourEndWeekThu: yup
    .string()
    .hour()
    .endHour(),
  hourStartWeekFri: yup.string().hour(),
  hourEndWeekFri: yup
    .string()
    .hour()
    .endHour(),
  hourStartWeekSat: yup.string().hour(),
  hourEndWeekSat: yup
    .string()
    .hour()
    .endHour()
});

export default schema;
